import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import { v4 as uuid } from "uuid";
import axios from "axios";
import { Formik } from "formik";
import * as Yup from "yup";
import InputAdornment from "@material-ui/core/InputAdornment";
import { BiCopy } from "react-icons/bi";
import Preview from "../components/Preview.js";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import Button2 from "@material-ui/core/Button";
import Input from "@material-ui/core/Input";
import SVG from "react-inlinesvg";
import ReactSelect from "../../UI/ReactSelect";


export default function Edit(props) {
  const {
    onHide,
    show,
    categoryName,
    onCategoryNames,
    skip,
    take,
    sortField,
    orderBy,
    orders
  } = props;
  const { id, nameAz, nameEn, nameRu, photo, order } = categoryName;


  const fileUrl = "https://cdn.deyerlisen.az/" + photo;
  const [files, setFiles] = useState("");
  const [preview, setPreview] = useState(true);
  const [imageSrc, setImageSrc] = useState(fileUrl);
  useEffect(() => {
    setImageSrc(fileUrl);
  }, [fileUrl]);



  const [isError, setIsError] = useState("");

  const [ordersOptions, setOrdersOptions] = useState([]);

  const [ordersOption, setOrdersOption] = React.useState(null);

  function handleChangeOrder(value, setFieldValue) {
    setOrdersOption((prevState) => value);
    setFieldValue("order", value.value);
    // console.log(value.value)
  }


  useEffect(() => {
    setOrdersOptions(
      orders.map((suggestion) => ({
        value: suggestion,
        label: suggestion,
      }))
    );
  }, [orders]);

  useEffect(() => {
    setOrdersOption((prev) =>
      // ordersOptions.find((option) => option === order)
      ordersOptions.find((option) => (option.value == order))
      
    );
  }, [order, ordersOptions]);


  useEffect(() => {
    if (!show) {
      setOrdersOption(null);
    }
  }, [show]);


  const handleCopyName = (name, values, setFieldValue) => {
    const nameAz = values.nameAz;
    setFieldValue(name, nameAz);
  };



  const imagePreview = (e) => {
    let reader = new FileReader();
    let file = e.target.files[0];
    setFiles(e.target.value);

    reader.onloadend = () => {
      setImageSrc(reader.result);
    };

    reader.readAsDataURL(file);

    setPreview(true);
  };
  const onClick = (e) => {
    setPreview(false);
    setImageSrc("");
    setFiles("");
  };

  const form = useRef(null);


  const onPutCategoryName = (values, resetForm, setSubmitting) => {
    // const categoryName = {
    //   id: id,
    //   nameAz: values.nameAz,
    //   nameEn: values.nameEn,
    //   nameRu: values.nameRu,
    // };
    const categoryName = new FormData(form.current);

    categoryName.append("order", values.order);


    axios
      .put(`${process.env.REACT_APP_API_URL}campaign/category`, categoryName, {
        headers: {
          "x-requestid": uuid(),
        },
      })
      .then(() => {
        onHide(false);
        resetForm();
        setSubmitting(false);
        onCategoryNames(skip, take, sortField, orderBy);
        setPreview(true);
        setImageSrc("");
        setFiles("");
      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
        }
      );
  };

  const EditSchema = Yup.object().shape({
    nameAz: Yup.string().required("Name Az is required"),
    nameEn: Yup.string().required("Name En is required"),
    nameRu: Yup.string().required("Name Ru is required"),

  });

  const getInputClasses = (touched, errors, filedName) => {
    if (touched[filedName] && errors[filedName]) {
      return true;
    }
    if (touched[filedName] && errors[filedName]) {
      return false;
    }

    return false;
  };

  useEffect(() => { }, [order]);


  return (
    <Modal
      size="sm"
      aria-labelledby="edit"
      show={show}
      onHide={onHide}
      centered
      className="modal-right pr-0"
    >
      {categoryName && Object.keys(categoryName).length !== 0 && categoryName.constructor === Object && (
        <Formik
          initialValues={{
            id: id,
            nameAz: nameAz,
            nameEn: nameEn,
            nameRu: nameRu,
            order: order,

          }}
          validationSchema={EditSchema}
          onSubmit={(values, { resetForm, setSubmitting }) => {
            onPutCategoryName(values, resetForm, setSubmitting);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleSubmit,
            handleChange,
            handleBlur,
            resetForm,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit} ref={form}>
              <Modal.Header closeButton>
                <Modal.Title id="edit">Edit</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="col-12 pl-4 pr-4">
                  <div className="row">
                    <div className="col-12 col-md-12 col-lg-12">
                      <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                        <input
                          type="hidden"
                          id="id"
                          name="id"
                          value={values.id}
                        />

                        <TextField
                          id="nameAz"
                          name="nameAz"
                          label="Name Az"
                          placeholder="Name Az"
                          className="w-100"
                          value={values.nameAz}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={getInputClasses(touched, errors, "nameAz")}
                        />
                      </div>
                      {touched.nameAz && errors.nameAz ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.nameAz}</div>
                        </div>
                      ) : null}
                    </div>
                    <div className="col-12 col-md-12 col-lg-12">
                      <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                        <TextField
                          id="nameEn"
                          name="nameEn"
                          label="Name En"
                          placeholder="Name En"
                          className="w-100"
                          value={values.nameEn}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={getInputClasses(touched, errors, "nameEn")}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment
                                position="end"
                                style={{ cursor: "pointer" }}
                              >
                                <BiCopy
                                  onClick={() => handleCopyName("nameEn", values, setFieldValue)}
                                  style={{
                                    width: "17px",
                                    height: "17px",
                                    color: "grey",
                                  }}
                                />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>
                      {touched.nameEn && errors.nameEn ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.nameEn}</div>
                        </div>
                      ) : null}
                    </div>
                    <div className="col-12 col-md-12 col-lg-12">
                      <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                        <TextField
                          id="nameRu"
                          name="nameRu"
                          label="Name Ru"
                          placeholder="Name Ru"
                          className="w-100"
                          value={values.nameRu}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={getInputClasses(touched, errors, "nameRu")}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment
                                position="end"
                                style={{ cursor: "pointer" }}
                              >
                                <BiCopy
                                  onClick={() => handleCopyName("nameRu", values, setFieldValue)}
                                  style={{
                                    width: "17px",
                                    height: "17px",
                                    color: "grey",
                                  }}
                                />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>
                      {touched.nameRu && errors.nameRu ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.nameRu}</div>
                        </div>
                      ) : null}

                    </div>


                    <div className="col-12 col-md-12 col-lg-12">
                      <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                        <ReactSelect
                          suggestions={ordersOptions}
                          handleChangeSingle={(value) =>
                            handleChangeOrder(value, setFieldValue)
                          }
                          single={ordersOption}
                          label="Order Id"
                          placeholder="Order Id"
                          inputId="order"
                          error={getInputClasses(touched, errors, "order")}
                        />
                      </div>

                      {touched.order && errors.order ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            {errors.order}
                          </div>
                        </div>
                      ) : null}
                    </div>


                    <div className="col-12 col-md-12 col-lg-12">
                      <div className="w-100 pt-2 pb-3">
                        <label htmlFor="contained-button-file">
                          <Input
                            accept="image/*"
                            id="contained-button-file"
                            type="file"
                            name="file"
                            label="File URL"
                            placeholder="File URL"
                            className="w-100"
                            onChange={imagePreview}
                            value={files}
                            hidden
                          />
                          <Button2 variant="contained" component="span">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Devices/Camera.svg"
                              )}
                              className="mr-2"
                            />
                            Change image
                          </Button2>
                        </label>
                        <Preview
                          preview={preview}
                          imageSrc={imageSrc}
                          onClick={onClick}
                        />
                      </div>
                      {touched.file && errors.file ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            {errors.file}
                          </div>
                        </div>
                      ) : null}
                      {isError && (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block MuiFormLabel-root Mui-error">
                            {isError}
                          </div>
                        </div>
                      )}
                      {isError && (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block MuiFormLabel-root Mui-error">
                            {isError}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="light"
                  onClick={() => {
                    onHide(false);
                    resetForm();
                  }}
                >
                  Close
                </Button>
                <Button type="submit">Edit</Button>
              </Modal.Footer>
            </form>
          )}
        </Formik>
      )}
    </Modal>
  );
}
